import axios from "axios";
import Loading from "./Loading";
import { useState } from "react";

const baseUrl =
  "https://raw.githubusercontent.com/penggguna/QuranJSON/master/surah/";
const format = ".json";

export default function PerSurah(props) {
  const [ayat, setAyat] = useState([]);
  const [namaSurah, setNamaSurah] = useState([]);
  const [loading, setLoading] = useState(true);
  const noSurah = props.nomor;
  axios({
    method: "GET",
    url: `${baseUrl}${noSurah}${format}`,
  }).then((result, i) => {
    setLoading(false);
    setAyat(result.data.verses);
    setNamaSurah(result.data.name);
  });

  if (loading) {
    return <Loading />;
  }
  return (
    <div className="gap">
      <div className="row g-0 d-flex justify-content-center">
        <div className="cards col-3 ">
          <div className="surah d-flex justify-content-center">
            <div className="nama-surah">{namaSurah}</div>
          </div>
        </div>
      </div>
      <div className="paper">
        <div>
          {ayat.map((aayat, index) => (
            <div className="ayat" key={index}>
              <span className="no-ayat">{aayat.number}</span>&nbsp;
              {aayat.text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
